const useSafeAsyncCallback = (cb) => async () => {
  try {
    return await cb();
  } catch (error) {
    console.error(error);
  }
};

export default useSafeAsyncCallback;
